module.exports = __webpack_public_path__ + "static/img/inn8.388d1f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dashu/inn8.jpg
// module id = m5W9
// module chunks = 1